import React from "react";
import TopicsComponent from "../components/topics/index";

const TopicsPage = () => {
  return (
    <>
      <TopicsComponent />
    </>
  );
};

export default TopicsPage;
